export default __webpack_public_path__ + "static/media/newUser.94dede44.svg";